<div class="m-4">
  <dhs-file-uploader [id]="'csvJson'" [config]="{ 'fileuploadertext': 'Upload Here','isContent':true}"
    [multiple]="false" [formatsAllowed]="'.csv'" [maxSize]="500" [resource]="'mediagallery'" [formAction]="'ADD'"
    (documentInfo)="onChange($event.fileInfo)" [compress_image]="false">
  </dhs-file-uploader>
</div>

@if (currentConfig && currentConfig.form) {
  <dhs-form [config]="currentConfig.config" [fieldGroup]="currentConfig.form"
    [data]="apiData" (saveFinished)="onSaveFinished($event)" [decorator]="self" [action]="'ADD'"
    [customButton]="{'Add':[{'label': 'Download Converted','icon': 'fa fa-download'}]}">
  </dhs-form>
}


